<script lang="ts">
	import type { FooterLinks } from './types';
	import SEOFooterLinkBlock from './SEOFooterLinkBlock.svelte';

	interface Props {
		partnersLinks: FooterLinks[];
	}

	const { partnersLinks }: Props = $props();
</script>

<section class="flex flex-col gap-0 p-0 m-0">
	{#each partnersLinks as link, index (index)}
		<SEOFooterLinkBlock title={link.label} links={link.links} />
	{/each}
</section>
